/**
 * Call a method on a custom element if the method exists and the custom
 * element is connected.
 * @param {HTMLElement} component custom element
 * @param {string} method
 */
export function callIfConnectedAndDefined(component, method, ...params) {
  if (typeof component[method] === "function" && component.isConnected) {
    component[method](...params);
  }
}
